var map = {
	"./account-number.svg": 1220,
	"./account-star.svg": 1221,
	"./account.svg": 1222,
	"./angle_down.svg": 1223,
	"./angle_up.svg": 1224,
	"./arrow_down.svg": 1225,
	"./arrow_right.svg": 1226,
	"./arrow_up.svg": 1227,
	"./back.svg": 1228,
	"./check-circle-fill.svg": 1229,
	"./close.svg": 1230,
	"./contact.svg": 1231,
	"./date.svg": 1232,
	"./delete.svg": 1233,
	"./device.svg": 1234,
	"./disable.svg": 1235,
	"./dropdown.svg": 1236,
	"./edit.svg": 1237,
	"./lookup.svg": 1238,
	"./plus_bold.svg": 1239,
	"./save.svg": 1240
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1480;


//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/assets/icons/svgs nonrecursive ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}! .svg$
// module id = 1480
// module chunks = 116